import { render, staticRenderFns } from "./inDevelopment.vue?vue&type=template&id=b4b35ebc&"
import script from "./inDevelopment.vue?vue&type=script&lang=js&"
export * from "./inDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports